import { useState } from 'react'
import { Popover } from 'antd'
import cn from 'classnames'
import { ReactComponent as Close24 } from 'assets/svg/Close24.svg'
import './style.scss'
import { TResponsiblePopover, TResponsiblePopoverContent } from './types'
import { Link } from '../../components/Link'
import { routes } from '../../router'
import { CellWithSubtitle } from '../../components/CellWithSubtitle/CellWithSubtitle'
import { LeadByIndicator } from '../../components/LeadByIndicator'
import { useContractPageContext } from '../../pages/Contracts/Providers/ContractPageContextProvider'
import { Typography } from '../../components/Typography'
import { LED_BY_LABEL } from '../../components/LeadByIndicator/constants'
import { getStatus } from './utils'

const CategoriesContent = ({
  led_by,
  categoriesList
}: TResponsiblePopoverContent) => {
  const {
    state: { isCanSeeCategoryDetails }
  } = useContractPageContext()

  return (
    <div className="column">
      {led_by.map((ledByOption) => {
        const categoriesListTitle =
          (categoriesList
            ? ledByOption.contract_category_organization_name
            : ledByOption.led_by_name) ?? LED_BY_LABEL[ledByOption.led_by]

        const status = ledByOption.status && getStatus(ledByOption.status)
        return (
          <CellWithSubtitle
            className="contract-link full-width"
            key={ledByOption.uuid}
            title={
              <div className="row full-width">
                {isCanSeeCategoryDetails && ledByOption.uuid ? (
                  <Link
                    to={`${routes.contracts}${routes.contractCategories}/${ledByOption.uuid}`}
                    className="full-width gap-8 align-center"
                  >
                    <LeadByIndicator value={ledByOption.led_by} />
                    {categoriesListTitle}
                    {status}
                  </Link>
                ) : (
                  <div className="full-width gap-8 align-center p-8 row">
                    <LeadByIndicator value={ledByOption.led_by} />
                    {categoriesListTitle}
                    {status}
                  </div>
                )}
              </div>
            }
          />
        )
      })}
    </div>
  )
}

const CategoriesPopover = ({
  led_by,
  portfolio,
  name,
  uuid,
  categoriesList
}: TResponsiblePopover) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleSetIsOpen = (open: boolean) => setIsOpen(open)

  const {
    state: { isCanSeeCategoryDetails, isCanSetUpEditCategory }
  } = useContractPageContext()

  const categoryLink =
    isCanSeeCategoryDetails && led_by[0]?.uuid
      ? `${routes.contracts}${routes.contractCategories}/${led_by[0].uuid}`
      : ''

  const categoryLinkWithParams = isCanSetUpEditCategory
    ? `${routes.contracts}${routes.contractCategories}/new?contract_category=${uuid}`
    : ''

  const redirectLink = led_by.length ? categoryLink : categoryLinkWithParams

  return led_by.length > 1 ? (
    <Popover
      className={cn('categories-responsible-cell', '')}
      trigger="click"
      overlayClassName={'categories-responsible-popover'}
      placement="topLeft"
      content={
        <CategoriesContent
          led_by={led_by}
          name={name}
          categoriesList={categoriesList}
        />
      }
      overlayInnerStyle={{
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto'
      }}
      align={{
        points: ['tl', 'tl']
      }}
      visible={isOpen}
      onVisibleChange={handleSetIsOpen}
      title={
        <div className="description-cell__content-header">
          <div className="description-cell__content-header__content column full-width gap-8">
            <div
              className="description-cell__title full_header row space-between"
              onClick={() => setIsOpen(false)}
            >
              <Typography.Headline6>{name}</Typography.Headline6>
              <Close24 />
            </div>
            <Typography.Body2 className="description-cell__content-header__content__caption">
              Choose which details to view
            </Typography.Body2>
          </div>
        </div>
      }
    >
      <CellWithSubtitle
        className="contract-link"
        title={name}
        onTitleClick={() => setIsOpen(true)}
        subtitle={portfolio}
      />
    </Popover>
  ) : (
    <CellWithSubtitle
      className="contract-link"
      title={redirectLink ? <Link to={redirectLink}>{name}</Link> : <>{name}</>}
      subtitle={portfolio}
    />
  )
}

export default CategoriesPopover
